import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StoreConstant } from '../store.constant';
import { GranteeState } from '../state/grantee.state';
import { AccessTypeSelection } from '../../../common/enums/access-type-selection.enum';
import { ClientTypes } from '../../../common/enums/client-types.enum';
import { GranteeIneligibleReasons } from '../../../common/enums/ineligible-scenarios.enum';
import { BulkAcceptPermissionResponseDTO } from '../../../common/dtos/access-permissions.dto';
import { ContentUtil, getAccessLevelLabelById } from '../../utils/content/content.util';

export const selectGranteeAccessType = createSelector(
    createFeatureSelector(StoreConstant.reducers.granteeReducer),
    (state: GranteeState): AccessTypeSelection => state.accessType,
);

export const selectGranteeClientType = createSelector(
    createFeatureSelector(StoreConstant.reducers.granteeReducer),
    (state: GranteeState): ClientTypes => state.clientType,
);

export const selectGranteeIneligibleReason = createSelector(
    createFeatureSelector(StoreConstant.reducers.granteeReducer),
    (state: GranteeState): GranteeIneligibleReasons => state.granteeIneligibleReason,
);

export const selectGranteeState = createSelector(
    createFeatureSelector(StoreConstant.reducers.granteeReducer),
    (state: GranteeState) => state,
);

export const selectGranteeRegulatoryQuestions = createSelector(
    createFeatureSelector(StoreConstant.reducers.granteeReducer),
    (state: GranteeState) => state.granteeRegulatoryQuestions,
);

export const selectGranteeFullRegError = createSelector(
    createFeatureSelector(StoreConstant.reducers.granteeReducer),
    (state: GranteeState): boolean => state.hasFullRegError,
);

export const selectGranteeErrorState = createSelector(
    createFeatureSelector(StoreConstant.reducers.granteeReducer),
    (state: GranteeState) => state.error,
);

export const selectBulkAcceptResponse = createSelector(
    createFeatureSelector(StoreConstant.reducers.granteeReducer),
    (state: GranteeState): BulkAcceptPermissionResponseDTO | null => state.bulkAcceptResponse,
);

export const selectAcceptAccessFlowPartialSuccessAccessLevelLabel = createSelector(
    selectGranteeAccessType,
    (accessType: AccessTypeSelection): string =>
        accessType ? getAccessLevelLabelById(accessType, ContentUtil.content) : '',
);

export const selectAcceptAccessFlowPartialSuccessAccountNames = createSelector(
    selectBulkAcceptResponse,
    (response: BulkAcceptPermissionResponseDTO | null): string[] => {
        if (!response?.results) {
            return [];
        }
        return response.results
            .filter((r) => r.confirmationNumber)
            .map((r) => r.accountName ?? r.accountId);
    },
);

export const selectIsMultiAccount = createSelector(
    createFeatureSelector(StoreConstant.reducers.granteeReducer),
    (state: GranteeState): boolean => state.isMultiAccount,
);
